import React, { ComponentPropsWithoutRef, memo } from "react";

interface TextInputProps extends ComponentPropsWithoutRef<"input"> {
  error?: string;
  touched?: boolean;
  title?: string;
  dataList?: string[];
  list?: string;
  icon?: React.ReactNode;
}

const TextInputV2 = ({
  error,
  touched,
  title,
  dataList,
  list,
  icon,
  ...props
}: TextInputProps) => {
  return (
    <div className="flex flex-col">
      {title ? (
        <label className="font-semibold text-xl color--blue mb-1">
          {title}
        </label>
      ) : null}
      <div
        className={`flex flex-row justify-between items-center borderWidth focus:border-bahama_blue rounded-md	border-gray-900 h-auto px-4 py-4 !text-black text-2xl
            ${touched && error ? "!border-red-500" : ""}
            `}
      >
        <input className="w-full" {...props} list={list} />
        {icon && icon}
      </div>

      {dataList ? (
        <datalist id={list}>
          {dataList.map((data) => (
            <option key={data} value={data} />
          ))}
        </datalist>
      ) : null}

      {touched && error ? (
        <div className="formElements__errorText">{error}</div>
      ) : null}
      <div className="invalid-feedback" />
    </div>
  );
};

export default memo(TextInputV2);
